// src/redux/store.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = { IsMenuOpen: false };

const menuSlice = createSlice({
  name: 'menuSate',
  initialState,
  reducers: {
    menuOpen: (state) => {
      state.IsMenuOpen = !state.IsMenuOpen;
    }
  },
});

export const { menuOpen } = menuSlice.actions;

export default menuSlice.reducer;


